import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import FiscalYear from "models/fiscal-year";

/** Visible fiscal years shared by every screen with a fiscal year dropdown (see hooks/useFiscalYearOptions). */
export interface FiscalYearsSliceState {
    /** null = not loaded yet (or invalidated after an admin change). */
    fiscalYears: FiscalYear[] | null;
}

export const initialState: FiscalYearsSliceState = {
    fiscalYears: null,
};

const FiscalYearsSlice = createSlice({
    name: "fiscal-years-slice",
    initialState,
    reducers: {
        setVisibleFiscalYears(state, { payload }: PayloadAction<FiscalYear[]>) {
            state.fiscalYears = payload;
        },
        invalidateVisibleFiscalYears(state) {
            state.fiscalYears = null;
        },
    },
});

export const {
    setVisibleFiscalYears,
    invalidateVisibleFiscalYears,
} = FiscalYearsSlice.actions;

export default FiscalYearsSlice.reducer;
